import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    list: [],
    page:0,
    limit:10,
    totalCount:0,
    totalPage:0,
    filters:{}
}
const communityPostSlice = createSlice({
    name: 'communityPost',
    initialState,
    reducers: {
        updateCommunityPostSlice: (state, action) => {
            return { ...state, ...action.payload };
        },
        resetCommunityPostSlice: (state, action) => {
            return initialState;
        }
    }
})

export const { updateCommunityPostSlice, resetCommunityPostSlice } = communityPostSlice.actions;
export default communityPostSlice.reducer;